import React, { useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  ResettPasswordAction,
  validateResetPasswordToken,
} from "../../Redux/Auth/AuthActions";
import { absoluteUrl } from "../../_helper";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import RowLoader from "../../Components/UI/RowLoader";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading } = useSelector((state) => state.Auth);

  const ResetPasswordInitialData = {
    password: "",
    password_confirmation: "",
  };

  const resetPasswordSchema = Yup.object().shape({
    password: Yup.string().min(6, "Password too short").required("Required"),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Password confirmation is required"),
  });

  const removeQueryParam = () => {
    // Create a new URL without any query parameters
    const newUrl = location.pathname;

    // Update the URL without reloading the page
    navigate(newUrl, { replace: true });
  };

  const onErrorHandler = (word) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: word,
    });
  };

  const onRestPasswordErrorHandler = (word) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: word,
    }).then((result) => {
      if (result.isConfirmed) {
        if (word === "Token Has Expired") navigate("/");
      }
    });
  };

  const onRestPasswordSuccessfully = () => {
    Swal.fire({
      icon: "success",
      title: "success",
      text: "your Password was changed successfully",
    });

    // to redirect to home (which is will be login)
    navigate("/");
  };

  useEffect(() => {
    if (searchParams.get("email") && searchParams.get("token")) {
      let email = searchParams.get("email");
      let token = searchParams.get("token");

      // if there is email and password (by redirection link from Email)
      // check email and token (if valid)>> remove email and link search paramters & save email and token info @forget password info @redux
      dispatch(
        validateResetPasswordToken(
          {
            type: "client",
            email,
            token,
          },
          // onSuccess
          removeQueryParam,
          onErrorHandler
        )
      );
    }
  }, []);

  return (
    <>
      <img
        src={absoluteUrl("imgs/loginLogo.png")}
        className="login-logo !-tw-mt-10 tw-mx-auto"
        alt=""
      />
      {/* <h4
        className="tw-text-white tw-text-center !tw-m-0 tw-font-bold tw-text-lg !-tw-mt-10"
        style={{ textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        UNITERS ACADEMY
      </h4>{" "} */}
      <h3 className="tw-text-lg text-center mb-3 !-tw-mt-10">Reset Password</h3>
      <Formik
        initialValues={ResetPasswordInitialData}
        validationSchema={resetPasswordSchema}
        onSubmit={(values) => {
          // same shape as initial values
          dispatch(
            ResettPasswordAction(
              values,
              onRestPasswordSuccessfully,
              onRestPasswordErrorHandler
            )
          );
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="form-group mb-3 position-relative">
              {/* <label className='c-white' htmlFor="password">Password</label> */}
              <div className="input-icon">
                <span className="fa fa-lock login-icon-field tw-text-secondary tw-text-xl"></span>
                <Field
                  name="password"
                  type="password"
                  placeholder="Password"
                  className={`form-control tw-border-b-2 pr-3 tw-border-secondary !tw-border-x-0 !tw-border-t-0 !tw-rounded-none  ${
                    errors.password && touched.password
                      ? "tw-border !tw-border-red-500"
                      : ""
                  }`}
                />
              </div>
              <ErrorMessage
                name="password"
                component="div"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group mb-3 position-relative">
              <div className="input-icon">
                <span className="fa fa-lock login-icon-field tw-text-secondary tw-text-xl"></span>
                <Field
                  name="password_confirmation"
                  type="password"
                  placeholder="Confirm Password"
                  className={`form-control tw-border-b-2 pr-3 tw-border-secondary !tw-border-x-0 !tw-border-t-0 !tw-rounded-none ${
                    errors.password_confirmation &&
                    touched.password_confirmation
                      ? "tw-border !tw-border-red-500"
                      : ""
                  }`}
                />
              </div>
              <ErrorMessage
                name="password_confirmation"
                component="div"
                className="invalid-feedback"
              />
            </div>

            <button
              type="submit"
              className="btn !tw-bg-primary tw-w-full tw-text-white mt-3 hover:!tw-text-[#eee] tw-h-10"
            >
              {isLoading ? <RowLoader /> : "Reset Password"}
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ResetPassword;
